// extracted by mini-css-extract-plugin
export default {"buyButton":"EeCsQ","hasInCart":"P3JGI","iconCheck":"gdHGK"};